import React from 'react';
import { useTheme } from '@veneer/theme';
import { SerializedStyles, css } from '@emotion/react';
import type { IconInterface } from './types';
import useColor from '../utils/use_color';
import focusRing from '../utils/focus_ring';

type StylesProps = {
  color?: IconInterface['color'];
  size?: IconInterface['size'];
  display: IconInterface['display'];
};

type StylesType = (props: StylesProps) => {
  base: SerializedStyles;
  disabled: SerializedStyles;
  rtlFlippable: SerializedStyles;
};

const useStyles: StylesType = ({ color, size, display }) => {
  const theme = useTheme();
  const imageColor = useColor(color ?? theme.color.foreground.default);

  return React.useMemo(() => {
    return {
      base: css({
        boxSizing: 'border-box',
        display,
        userSelect: 'none',
        width: size,
        height: size,
        color: imageColor,
        fill: 'currentColor',
        ...focusRing(theme),
      }),

      disabled: css({
        color: theme.color.foreground.disabled,
        cursor: 'default',
        filter: 'grayscale(1)',
      }),

      rtlFlippable: css({
        transform: 'scaleX(-1)',
      }),
    };
  }, [display, imageColor, size, theme]);
};

export default useStyles;
